// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3Loiz","productName":"Table_productName__8yUm8"};